/**
 * @generated SignedSource<<53e740b0d2c92621274c0faf8e9b1e75>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flowStepId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stepState",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateFlowStepMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateFlowStepTPayload",
        "kind": "LinkedField",
        "name": "updateFlowStepTByFlowStepId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FlowStepT",
            "kind": "LinkedField",
            "name": "flowStepT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateFlowStepMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateFlowStepTPayload",
        "kind": "LinkedField",
        "name": "updateFlowStepTByFlowStepId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FlowStepT",
            "kind": "LinkedField",
            "name": "flowStepT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "45c6e8d64301ffde02472122511d795a",
    "id": null,
    "metadata": {},
    "name": "UpdateFlowStepMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateFlowStepMutation(\n  $input: UpdateFlowStepTByFlowStepIdInput!\n) {\n  updateFlowStepTByFlowStepId(input: $input) {\n    flowStepT {\n      flowStepId\n      stepState\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "cf119989eb1eb66e0f7d61ebe8250fd9";

module.exports = node;
